import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Auto-refresh access_token on 401 (single retry to avoid loops)
let refreshInFlight = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const status = error?.response?.status;
    const url = original.url || "";
    const isAuthEndpoint = url.includes("/auth/login") || url.includes("/auth/register") || url.includes("/auth/refresh") || url.includes("/auth/logout");
    if (status === 401 && !original._retried && !isAuthEndpoint) {
      original._retried = true;
      try {
        refreshInFlight = refreshInFlight || api.post("/auth/refresh").finally(() => { refreshInFlight = null; });
        await refreshInFlight;
        return api(original);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function apiError(e) {
  // Try the common backend error fields in order. This handles both our own
  // FastAPI errors ({detail}) and third-party or middleware errors that use
  // {error} or {message} shapes (e.g. slowapi's default, generic 4xx JSON).
  const data = e?.response?.data;
  if (data) {
    const fromDetail = formatApiErrorDetail(data.detail);
    if (fromDetail && fromDetail !== "Something went wrong. Please try again.") return fromDetail;
    if (typeof data.error === "string" && data.error.trim()) return data.error;
    if (typeof data.message === "string" && data.message.trim()) return data.message;
    if (data.detail) return formatApiErrorDetail(data.detail);
  }
  return e?.message || "Request failed";
}
